const EMAIL = /[^\s@<>(),;]+@[^\s@<>(),;]+\.[^\s@<>(),;]+/g;
const NUMBER_RUN = /\+?\(?\d[\d\s\-().]{5,}\d/g;
const PHONE_MIN_DIGITS = 9;

export const scrubContactData = (text: string): string =>
    text
        .replace(EMAIL, '')
        .replace(NUMBER_RUN, (run: string) => (run.replace(/\D/g, '').length >= PHONE_MIN_DIGITS ? '' : run))
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+([,.;:])/g, '$1')
        .trim();
